export default "__VITE_ASSET__3ebc4575__"